import { specOrPending } from '../utils/stock'

export default function SpecValue({ value }) {
  const { text, pending, na } = specOrPending(value)
  return <span className={pending || na ? 'spec-muted' : undefined}>{text}</span>
}
